import { FC, useMemo } from "react";
import IProjetosPropostaInformacoesGarantiaComponentes from "./types";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import './styles.css';

interface OrdemServicoManutencaoGarantiasProps {
    informacoesGarantia: IProjetosPropostaInformacoesGarantiaComponentes[];
    temServico: boolean;
    componentes: any;
    segmento_projeto?: string;
}

const OrdemServicoManutencaoGarantias: FC<OrdemServicoManutencaoGarantiasProps> = ({
    informacoesGarantia,
    temServico,
    componentes,
    segmento_projeto,
}) => {

    const categoriasCompParceiros = useMemo(() => {
        return componentes.filter((comp: any) => comp.parceiro !== "Intelbras" && !(comp.parceiro === "")).map((comp: any) => comp.categoria_componentes_id);
    }, [componentes]);

    const componentesParceiros = useMemo(() => {
        return componentes.filter((comp: any) => comp.parceiro !== "Intelbras" && !(comp.parceiro === "")).map((comp: any) => comp);
    }, [componentes]);

    const categoriasCompIntelbras = useMemo(() => {
        return componentes.filter((comp: any) => comp.parceiro === "Intelbras" || (comp.parceiro === "")).map((comp: any) => comp.categoria_componentes_id);
    }, [componentes]);
    return <>
        <div className="sub-title-minor">Manutenção</div>
        <div className="default-text-list" style={{ marginBottom: "12pt" }}><span>A manutenção dos produtos deve ser feita de acordo com as recomendações do manual do produto e a limpeza deve ser feita pela equipe habilitada. Entre em contato com a empresa responsável pela instalação do seu sistema ou uma Revenda Intelbras.</span></div>
        <div className="default-text-list" style={{ marginBottom: "12pt" }}><span>A Intelbras não recomenda que o cliente realize a manutenção do sistema ou limpeza dos módulos por conta própria.</span></div>

        <div className="sub-title-minor">Garantias</div>

        <div className="default-text-list"><span>O Grupo Intelbras possui garantia assegurada contra defeitos de fabricação que impeçam o funcionamento dos equipamentos. A garantia é válida de acordo com suas especificações e por período determinado a partir da emissão da nota fiscal, e só pode ser acionada mediante apresentação da nota, conforme tabelas abaixo.</span></div>

        <Table component={Paper} size="small" className="table">
            <TableHead>
                <TableRow>
                    <TableCell className="tableColEquipamentoHead font-intelbras-bold bg-verde-intelbras">Equipamentos</TableCell>
                    <TableCell className="tableColEquipamentoHead font-intelbras-bold bg-verde-intelbras">Garantias</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {informacoesGarantia.filter((item: any) => item?.garantia?.valor > 0).map(item => {
                    let textoGarantiaParceiro = "";
                    if (item.ids.some(id => categoriasCompParceiros.includes(id))) {
                        const componenteParceiro = componentesParceiros.find((comp: any) => comp.categoria_componentes_id === (item.ids.find(id => categoriasCompParceiros.includes(id))));
                        textoGarantiaParceiro = componenteParceiro?.descricao_garantia || "";
                    }
                    return (
                        <>
                            {segmento_projeto === "on" ? <>
                                {item.ids.some(id => categoriasCompParceiros.includes(id)) ?
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            <span>{item.label} de Parceiros</span>
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            <span>{textoGarantiaParceiro || "-"}</span>
                                        </TableCell>
                                    </TableRow> : null}
                                {item.ids.some(id => categoriasCompIntelbras.includes(id)) ?
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            <span>{item.label} Grupo Intelbras</span>
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            <span>{item.garantia.valor} {item.garantia.unidade} de {item.garantia.tipo} {item.performance ? `e ${item.performance.valor} ${item.performance.unidade} de performance` : ''}</span>
                                        </TableCell>
                                    </TableRow> : null}
                            </> : 
                                <>
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            <span>{item.label} Grupo Intelbras</span>
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            <span>{item.garantia.valor} {item.garantia.unidade} de {item.garantia.tipo} {item.performance ? `e ${item.performance.valor} ${item.performance.unidade} de performance` : ''}</span>
                                        </TableCell>
                                    </TableRow>
                                {item.ids.some(id => categoriasCompParceiros.includes(id)) ? <>
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            <span>{item.label} de Parceiros</span>
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            <span>{textoGarantiaParceiro || "-"}</span>
                                        </TableCell>
                                    </TableRow>
                                </> : null}
                            </>}
                        </>
                    )
                })}
            </TableBody>
        </Table>

        <div className="default-text-list" style={{ marginBottom: "12pt", marginTop: "25pt" }}><span>Os prazos, as condições e respectivas exclusões de garantia, estão descritas no manual de cada produto, e deverão ser acionadas junto à revenda.</span></div>
        <div className="default-text-list" style={{ marginBottom: "12pt" }}><span>Os produtos Renovigi, pertencentes ao Grupo Intelbras, entregam a mesma qualidade reconhecida e um pós-venda confiável que garante tranquilidade e suporte completo para seus projetos.</span></div>
        <div className="default-text-list" style={{ marginBottom: "12pt" }}><span>Além das previsões descritas no manual de cada produto e informações apresentadas pela revenda, o cliente deve estar ciente que qualquer alteração na estrutura, modificação e abertura dos equipamentos, reconfiguração ou desinstalação do sistema gerador solar, que não seja feita pela revenda, compromete a garantia de todo sistema.</span></div>
        <div className="default-text-list default-small-text" style={{ fontSize: "11pt" }}><span>*Para informações detalhadas de performance dos produtos, consulte a ficha técnica.</span></div>
        <div className="default-text-list default-small-text" style={{ fontSize: "11pt" }}><span>*Para maiores informações quanto a garantia de módulos e estruturas de parceiros ou políticas de pós-vendas, consulte as informações no site <a href="https://www.intelbras.com/"><span>intelbras.com</span></a>.</span></div>
    </>
}

export default OrdemServicoManutencaoGarantias;